import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {DatabaseService} from "../../services/database/database.service";
import {Database} from "../../models/database";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  database: Database;
  projectId: string;
  databaseId: string;

  constructor(
    private route: ActivatedRoute,
    private databaseService: DatabaseService,
  ) {
  }

  ngOnInit() {
    this.projectId = this.route.snapshot.params.project_id;
    this.databaseId = this.route.snapshot.params.database_id;

    if (!this.projectId || !this.databaseId)
      return;

    this.loadDatabase(this.projectId, this.databaseId);

    // todo ma che fa sto codice??
    this.route.params.subscribe(params => {
      if (this.databaseId !== params['database_id'])
        return;
      else if (this.projectId !== params['project_id'])
        return;
      else
        this.loadDatabase(params['project_id'], params['database_id']);
    });
    // fine todo

    this.databaseService.onChange
      .subscribe(
        () => {
          this.database = this.databaseService.database;
        },
        console.error
      )
  }

  loadDatabase(projectId, databaseId) {
    this.databaseService.getSingleDatabase(projectId, databaseId)
      .subscribe(
        () => this.database = this.databaseService.database,
        e => console.log(e));
  }
}
